var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3289_1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-170.126 0H973.393V600H-170.126V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170.126 69.231H973.393ZM973.393 161.539H-170.126ZM-170.126 253.846H973.393ZM973.393 346.154H-170.126ZM-170.126 438.462H973.393ZM973.393 530.769H-170.126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170.126 69.231H973.393M973.393 161.539H-170.126M-170.126 253.846H973.393M973.393 346.154H-170.126M-170.126 438.462H973.393M973.393 530.769H-170.126",
    stroke: "white",
    strokeWidth: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170.126 0H287.281V323.077H-170.126V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4616 13.8462L31.3465 47.2434L2.84961 26.6028H38.0738L9.57677 47.2434L20.4616 13.8462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4616 78.4614L31.3465 111.859L2.84961 91.218H38.0738L9.57677 111.859L20.4616 78.4614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4616 143.077L31.3465 176.474L2.84961 155.834H38.0738L9.57677 176.474L20.4616 143.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4616 207.692L31.3465 241.09L2.84961 220.449H38.0738L9.57677 241.09L20.4616 207.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4616 272.308L31.3465 305.705L2.84961 285.064H38.0738L9.57677 305.705L20.4616 272.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5788 46.1538L69.4637 79.551L40.9668 58.9104H76.191L47.694 79.551L58.5788 46.1538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5788 110.769L69.4637 144.166L40.9668 123.526H76.191L47.694 144.166L58.5788 110.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5788 175.385L69.4637 208.782L40.9668 188.141H76.191L47.694 208.782L58.5788 175.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5788 240L69.4637 273.397L40.9668 252.757H76.191L47.694 273.397L58.5788 240Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.696 13.8462L107.581 47.2434L79.084 26.6028H114.308L85.8111 47.2434L96.696 13.8462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.696 78.4614L107.581 111.859L79.084 91.218H114.308L85.8111 111.859L96.696 78.4614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.696 143.077L107.581 176.474L79.084 155.834H114.308L85.8111 176.474L96.696 143.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.696 207.692L107.581 241.09L79.084 220.449H114.308L85.8111 241.09L96.696 207.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.696 272.308L107.581 305.705L79.084 285.064H114.308L85.8111 305.705L96.696 272.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.813 46.1538L145.698 79.551L117.201 58.9104H152.425L123.928 79.551L134.813 46.1538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.813 110.769L145.698 144.166L117.201 123.526H152.425L123.928 144.166L134.813 110.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.813 175.385L145.698 208.782L117.201 188.141H152.425L123.928 208.782L134.813 175.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.813 240L145.698 273.397L117.201 252.757H152.425L123.928 273.397L134.813 240Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93 13.8462L183.815 47.2434L155.318 26.6028H190.543L162.046 47.2434L172.93 13.8462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93 78.4614L183.815 111.859L155.318 91.218H190.543L162.046 111.859L172.93 78.4614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93 143.077L183.815 176.474L155.318 155.834H190.543L162.046 176.474L172.93 143.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93 207.692L183.815 241.09L155.318 220.449H190.543L162.046 241.09L172.93 207.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93 272.308L183.815 305.705L155.318 285.064H190.543L162.046 305.705L172.93 272.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.048 46.1538L221.932 79.551L193.436 58.9104H228.66L200.163 79.551L211.048 46.1538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.048 110.769L221.932 144.166L193.436 123.526H228.66L200.163 144.166L211.048 110.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.048 175.385L221.932 208.782L193.436 188.141H228.66L200.163 208.782L211.048 175.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.048 240L221.932 273.397L193.436 252.757H228.66L200.163 273.397L211.048 240Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.165 13.8462L260.05 47.2434L231.553 26.6028H266.777L238.28 47.2434L249.165 13.8462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.165 78.4614L260.05 111.859L231.553 91.218H266.777L238.28 111.859L249.165 78.4614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.165 143.077L260.05 176.474L231.553 155.834H266.777L238.28 176.474L249.165 143.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.165 207.692L260.05 241.09L231.553 220.449H266.777L238.28 241.09L249.165 207.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.165 272.308L260.05 305.705L231.553 285.064H266.777L238.28 305.705L249.165 272.308Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3289_1000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 300C0 134.315 134.315 0 300 0V0C465.685 0 600 134.315 600 300V300C600 465.685 465.685 600 300 600V600C134.315 600 0 465.685 0 300V300Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usaFlag.696180a9ac298aab1c4153e20857af36.svg";
export { ForwardRef as ReactComponent };